import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import LegoAdminPageContext from '../../legoAdminPageContext';

export default function RemapSpecGroupsTable({ specGroupIds, onRemapped, objects }) {
    const { page } = useContext(LegoAdminPageContext);

    const [loading, setLoading] = useState(true);
    const [remapData, setRemapData] = useState(null);
    const [specGroupsById, setSpecGroupsById] = useState(_.keyBy(objects, '_id'));
    const [selection, setSelection] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await page.service('/services/cerokm/specsgroup-remap').find({ query: { specGroupIds } });
                
                setRemapData(res);    
                            
                setSelection(_.mapValues(res, (value, key) => true));
            } catch (error) {                
                console.error("Error fetching remap data", error);
            }
            setLoading(false);
        };

        fetchData();
    }, [specGroupIds]);

    const handleSelectionChange = (id) => {
        setSelection(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        const newSelection = {};
        if (remapData) {
            Object.keys(remapData).forEach(id => {
                newSelection[id] = isChecked;
            });
        }
        setSelection(newSelection);
    };

    const handleRemap = async () => {
        const selectedRemapData = _.pickBy(remapData, (value, key) => selection[key]);
        if (_.isEmpty(selectedRemapData)) {
            return;
        }

        try {
            let res = await page.service('/services/cerokm/specsgroup-remap').patch(null, {remap: selectedRemapData});
            onRemapped(res);
        } catch (error) {
            console.error("Error remapping spec groups", error);
            page.showNotification({level: 'error', title: 'Error remapping spec groups', body: error.message});
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!remapData || _.isEmpty(remapData)) {
        return <div>No remap data found.</div>
    }

    const selectedCount = Object.values(selection).filter(Boolean).length;
    const allSelected = remapData && Object.keys(remapData).length > 0 && selectedCount === Object.keys(remapData).length;

    return (
        <div>
            <table className='table table-sm table-bordered small'>
                <thead>
                    <tr>
                        <th><input type="checkbox" checked={allSelected} onChange={handleSelectAll} /></th>
                        <th colSpan={3} className="text-center">FROM</th>
                        <th colSpan={3} className="text-center">TO</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Trim</th>
                        <th>Trim</th>
                        <th>Name</th>
                        <th>ID</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(remapData).map(([id, subtrimIds]) => (
                        <tr key={id}>
                            <td><input type="checkbox" checked={!!selection[id]} onChange={() => handleSelectionChange(id)} /></td>
                            <td>{id}</td>
                            <td>{specGroupsById[id]?.name}</td>
                            <td>{specGroupsById[id]?.context.trim || ''}</td>
                            <td>
                                {subtrimIds.map(subtrimId => <div key={subtrimId}>{specGroupsById[subtrimId]?.context.trim || ''}</div>)}
                            </td>
                            <td>
                                {subtrimIds.map(subtrimId => <div key={subtrimId}>{specGroupsById[subtrimId]?.name || 'NOT FOUND'}</div>)}
                            </td>
                            <td>
                                {subtrimIds.map(subtrimId => <div key={subtrimId}>{subtrimId}</div>)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button className='btn btn-primary' onClick={handleRemap} disabled={selectedCount === 0}>
                Remap {selectedCount} selected groups
            </button>
        </div>
    );
}
